import React from "react";
import { Field } from "redux-form";
import { ReduxControls } from "rhombus-react";
import { mediaBuyerEmail } from 'widgets/forms/validators/LibraryProperties';
import PropTypes from 'prop-types';

import "./SubmitCreativeEmailField.css";

const checkboxFields = {
	noInitialMediaBuyer: {
		checkboxName:"sendMediaBuyerEmail",
		fieldLabel:"Send confirmation to Media Buyer",
	},
	mediaBuyer:{
		checkboxName:"sendMediaBuyerEmail",
		fieldLabel:"Send confirmation to Media Buyer",
	},
	primary: {
		checkboxName:"sendPrimaryEmail",
		fieldLabel:"Send confirmation to Primary Contact",
	},
};

/**
 * Conditional react-redux checkbox field component that has custom labeling
 * and includes an inline input field if an initial email value is not included.
 *
 * @example
 * const emailType = 'mediaBuyer'
 * const email = '',
 * const initial = false
 * return (
 *    <SubmitCreativeEmailField
 *       emailType={emailType}
 *       email={email}
 *       initial={initial}
 *    />)
 * @param {string} emailType - designates the type of checkbox and return
 * @param {string} email - email to be included in form submission
 * @param {boolean} initial - true if there is an initialValue for the email field
 * @returns functional component
 */
export default function  SubmitCreativeEmailField({ emailType, email, initial }){
	let fieldType = emailType
		, standard = initial || emailType === "primary"
		, mediaBuyerInputField = null
	;

	if(!standard){
		fieldType = "noInitialMediaBuyer";
		mediaBuyerInputField = (
			<Field
				name="mediaBuyerEmail"
				type="text"
				className= "media-buyer-email"
				component={ ReduxControls.Input }
				placeholder="Enter Email Address"
				autoFocus
				required
				validate={[mediaBuyerEmail]}
			 />
		);
	}

	let { checkboxName, fieldLabel } = checkboxFields[fieldType]
		, checkboxLabel = standard ? email : ""
		,	fieldReturn = (
			<>
				<Field
					name={checkboxName}
					type="checkbox"
					label={checkboxLabel}
					component={ ReduxControls.Checkbox }
				/>
				{mediaBuyerInputField}
			</>
		);


	return (
		<div className="submit-ad-email-group e-form__control-wrapper">
			<label className="submit-ad-checkbox-label e-form__control-label">{fieldLabel}</label>
			<div className="submit-ad-email-recip">
				{fieldReturn}
			</div>
		</div>
	);
}

SubmitCreativeEmailField.defaultProps = {
	emailType:     "",
	email:         "",
	initial:       true,
};

SubmitCreativeEmailField.propsTypes = {
	emailType:     PropTypes.string.isRequired,
	email:         PropTypes.string.isRequired,
	initial:       PropTypes.bool,
};
